import React, { createContext, useState, useEffect } from "react";



export const SiteStateContext = createContext();


export const SiteStateProvider = ({ children }) =>
{
  const [status, setStatus] = useState(

    () =>
    {
      const storedStatus = localStorage.getItem("userStatus");
      if (!storedStatus || storedStatus === "All") {
        return "All Scans";
      }
      return storedStatus;
    }
  );
  const [impersonateTeamId, setImpersonateTeamId] = useState(() =>
  localStorage.getItem("adminImpersonateTeamId") || ""
  );
  const [impersonateTeamName, setImpersonateTeamName] = useState(() =>
  localStorage.getItem("adminImpersonateTeamName") || ""
  );

  useEffect(

    () =>
    {

      localStorage.setItem("userStatus", status);

    }, [status]
  );
  useEffect(() => {
    if (impersonateTeamId) {
      localStorage.setItem("adminImpersonateTeamId", impersonateTeamId);
    } else {
      localStorage.removeItem("adminImpersonateTeamId");
    }
  }, [impersonateTeamId]);
  useEffect(() => {
    if (impersonateTeamName) {
      localStorage.setItem("adminImpersonateTeamName", impersonateTeamName);
    } else {
      localStorage.removeItem("adminImpersonateTeamName");
    }
  }, [impersonateTeamName]);


  const value =
  {
    status,
    setStatus,
    impersonateTeamId,
    setImpersonateTeamId,
    impersonateTeamName,
    setImpersonateTeamName,
    isImpersonating: Boolean(impersonateTeamId)

  };

  return (
    <SiteStateContext.Provider value={value}> {children}</SiteStateContext.Provider>);


};